import { SafetyOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { Button, Modal, Select, DatePicker, ConfigProvider, Typography, Tag } from 'antd'
import frFR from 'antd/locale/fr_FR'
import dayjs from 'dayjs'
import React from 'react'
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';

const { Text } = Typography;

const DerogationUtilisateur = ({ utilisateur, requireActive, infoButtonStyle, habilitations, navigate, param, modules, isSecurityLocked, securityLockMessage }) => {
    const [derogationModalOpen, setDerogationModalOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [selectedHabilitations, setSelectedHabilitations] = React.useState([]);
    const [dateFinDerogation, setDateFinDerogation] = React.useState(null);
    const isDisabled = !utilisateur?.active || isSecurityLocked;
    const disabledButtonStyle = {
        backgroundColor: '#E5E7EB',
        borderColor: '#E5E7EB',
        color: '#9CA3AF',
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
    };

    const handleSelectChange = (value) => {
        let selectedHabs = [];
        value.forEach((el) => {
            let h = habilitations.find((e) => e.habilitationId === parseInt(el));
            selectedHabs.push(h);
        });
        setSelectedHabilitations(selectedHabs);
    };


    // Fonction qui filtre les habilitations afin de ressortir celles d'un module spécifique défini par son moduleId
    const getHabilitationsOfModule = (moduleId) => {
        let habs = habilitations.filter((e) => e.module.moduleId === moduleId);
        let opt = [];
        // Dérogation encore active (non expirée) → on masque ses habilitations pour
        // éviter de les ré-octroyer avant la date d'expiration.
        const derogationActive = utilisateur?.dateFinDerogation
            && dayjs(utilisateur.dateFinDerogation).isAfter(dayjs());
        let habbs = habs.filter(
            (e) =>
                !utilisateur?.profil?.habilitations.some(
                    (f) => f.habilitationId === e.habilitationId
                )
                && !(derogationActive && utilisateur?.derogation?.some(
                    (f) => f.habilitationId === e.habilitationId
                ))
        );
        habbs.forEach((hab, id) => {
            opt.push({
                key: id,
                label: hab.libelle,
                value: hab.habilitationId,
            });
        });
        return opt;
    };

    const getUpdateHabilitationsOfModule = (moduleId) => {
        let habs = selectedHabilitations.filter(
            (e) => e.module.moduleId === moduleId
        );
        // console.log("habits...: ", habs);
        let opt = [];
        habs.forEach((hab, id) => {
            opt.push({
                key: id,
                label: hab.libelle,
                value: hab.habilitationId,
            });
        });
        return opt;
    };

    const closeModal = () => {
        setDerogationModalOpen(false);
        setSelectedHabilitations([]);
        setDateFinDerogation(null);
    };

    const onSubmit = () => {
        if (requireActive("octroyer une dérogation")) return;
        if (isSecurityLocked) {
            toast(securityLockMessage || "Action non autorisée.");
            return;
        }
        // Validation : au moins une habilitation + une date/heure de fin valide
        if (!selectedHabilitations || selectedHabilitations.length === 0) {
            toast("Veuillez sélectionner au moins une habilitation.");
            return;
        }
        if (!dateFinDerogation) {
            toast("Veuillez préciser la date et l'heure de fin de dérogation.");
            return;
        }
        if (!dateFinDerogation.isAfter(dayjs())) {
            toast("La date de fin de dérogation doit être dans le futur.");
            return;
        }
        setLoading(true);
        // Fusionner avec les dérogations actives existantes (masquées du sélecteur) pour ne pas
        // les perdre lors d'un nouvel octroi avant expiration. Dédoublonnage par habilitationId.
        const derogationEncoreActive = utilisateur?.dateFinDerogation
            && dayjs(utilisateur.dateFinDerogation).isAfter(dayjs());
        const derogationsExistantes = derogationEncoreActive && Array.isArray(utilisateur?.derogation)
            ? utilisateur.derogation : [];
        const derogationFusionnee = [...derogationsExistantes];
        selectedHabilitations.forEach((h) => {
            if (!derogationFusionnee.some((f) => f.habilitationId === h.habilitationId)) {
                derogationFusionnee.push(h);
            }
        });
        utilisateur.derogation = derogationFusionnee;
        // Format LocalDateTime (sans fuseau) attendu par le backend
        utilisateur.dateFinDerogation = dateFinDerogation.format("YYYY-MM-DDTHH:mm:ss");
        axiosInstance
            .put(`/api/utilisateur/derogation`, JSON.stringify(utilisateur))
            .then((res) => {
                setLoading(false);
                closeModal();
                navigate(`/details-utilisateur/${res.data.codeId}`, { replace: true });
                toast("Dérogation octroyée avec succès");
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors de l'octroi de la dérogation");
                setLoading(false);
            });
    };


    return (
        <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '24px',
            border: '2px solid #E6F0FF',
            transition: 'all 0.3s ease'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    backgroundColor: '#E6F0FF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <SafetyOutlined style={{ fontSize: '24px', color: '#242166' }} />
                </div>
                <div>
                    <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#242166', margin: 0 }}>
                        Dérogation
                    </h4>
                    <p style={{ fontSize: '12px', color: '#6B7280', margin: 0 }}>
                        Permissions temporaires
                    </p>
                </div>
            </div>
            <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '16px' }}>
                Accordez des permissions spéciales temporaires à l'utilisateur
            </p>
            {securityLockMessage && (
                <p style={{ fontSize: '12px', color: '#b45309', marginBottom: '12px' }}>
                    {securityLockMessage}
                </p>
            )}
            <Button
                icon={<SafetyOutlined />}
                block
                onClick={() => {
                    if (isSecurityLocked) {
                        toast(securityLockMessage || "Action non autorisée.");
                        return;
                    }
                    setDerogationModalOpen(true);
                }}
                disabled={isDisabled}
                style={isDisabled ? { ...infoButtonStyle, ...disabledButtonStyle } : infoButtonStyle}
            >
                Octroyer une dérogation
            </Button>

            <Modal
                open={derogationModalOpen && !isSecurityLocked}
                onCancel={closeModal}
                zIndex={2000}
                centered
                onOk={onSubmit}
                confirmLoading={loading}
                title={
                    <span style={{ color: '#242166', fontWeight: 600 }}>
                        <SafetyOutlined style={{ marginRight: 8 }} />
                        Octroyer une dérogation
                    </span>
                }
                okText="Octroyer la dérogation"
                cancelText="Annuler"
                width={620}
            >
                <form id="addNewAddressForm" className="row g-12" onSubmit={onSubmit}>
                    <div className="col-12 col-md-12">
                        <div className="text-center">
                            <p className="address-subtitle">
                                Octroyer une dérogation à{" "}
                                <b>
                                    {utilisateur?.personne?.nom} {utilisateur?.personne?.prenom}
                                </b>
                            </p>
                        </div>
                        {/* <br /> */}
                        <div class="row">
                            {modules?.map((mod, id) => {
                                const moduleOptions = getHabilitationsOfModule(mod.moduleId);
                                // Aucune habilitation disponible (toutes déjà octroyées via le
                                // profil ou une dérogation active) → on n'affiche pas le module.
                                if (!moduleOptions || moduleOptions.length === 0) {
                                    return null;
                                }
                                return (
                                    <div class="col-md-12 select2-primary" key={id}>
                                        <label class="form-label" for="formtabs-language">
                                            {mod?.nom}
                                        </label>
                                        <Select
                                            mode="multiple"
                                            style={{
                                                width: "100%",
                                            }}
                                            placeholder="Veuillez sélectionner les habilitations spéciales sur le module"
                                            onChange={handleSelectChange}
                                            options={moduleOptions}
                                            defaultValue={
                                                param.profilId
                                                    ? getUpdateHabilitationsOfModule(mod.moduleId)
                                                    : []
                                            }
                                            value={getUpdateHabilitationsOfModule(mod.moduleId)}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                        <hr />
                        <div className="col-md-12 col-12">
                            <label className="form-label" style={{ fontWeight: 600, color: '#242166' }}>
                                <ClockCircleOutlined style={{ marginRight: 6 }} />
                                Date et heure de fin de dérogation <span style={{ color: '#ff4d4f' }}>*</span>
                            </label>
                            <ConfigProvider locale={frFR}>
                                <DatePicker
                                    showTime={{ format: 'HH:mm', defaultValue: dayjs('23:59:59', 'HH:mm:ss') }}
                                    format="DD/MM/YYYY HH:mm"
                                    style={{ width: '100%' }}
                                    value={dateFinDerogation}
                                    onChange={(val) => setDateFinDerogation(val)}
                                    disabledDate={(current) => current && current < dayjs().startOf('day')}
                                    placeholder="Choisir la date et l'heure de fin"
                                />
                            </ConfigProvider>
                            <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 6 }}>
                                La dérogation expirera automatiquement à cette échéance.
                                {dateFinDerogation && (
                                    <Tag color="blue" style={{ marginLeft: 8 }}>
                                        Expire le {dateFinDerogation.format('DD/MM/YYYY [à] HH:mm')}
                                    </Tag>
                                )}
                            </Text>
                        </div>
                    </div>
                </form>
                {/* </Modal.Body> */}
            </Modal>
        </div>
    )
}

export default DerogationUtilisateur
